export default __webpack_public_path__ + "static/chart-customisation-b19be6f7dd299d1279faf9ae77787440.png";